import { LILAC_200, LILAC_300, LILAC_500, WHITE, checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getFilterSectionMobileStyles = props => {
  var spacing = tokens.spacing,
    borderRadius = tokens.borderRadius;
  var isInsideModal = props.isInsideModal;
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: LILAC_300
    },
    showAsFullPage: {
      flex: 1,
      padding: isInsideModal ? spacing.SPACING_0 : spacing.SPACING_20,
      paddingBottom: spacing.SPACING_0
    },
    topHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: spacing.SPACING_28,
      paddingTop: spacing.SPACING_2
    },
    borderHorizontal: {
      height: 1,
      width: '100%'
    },
    borderVertical: {
      height: '100%',
      width: 1
    },
    content: {
      marginTop: spacing.SPACING_12,
      flexDirection: 'row'
    },
    row: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    center: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    leftPanel: {
      width: '40%',
      marginLeft: -spacing.SPACING_20,
      flex: 1
    },
    rightPanel: {
      backgroundColor: LILAC_200,
      width: '60%',
      paddingHorizontal: spacing.SPACING_24,
      marginRight: -spacing.SPACING_20,
      flex: 1
    },
    categoryContainer: {
      paddingVertical: spacing.SPACING_15,
      paddingLeft: spacing.SPACING_20
    },
    categorySelectedContainer: {
      backgroundColor: LILAC_200
    },
    categoryContainerText: {
      marginLeft: spacing.SPACING_4
    },
    notifierContainer: {
      justifyContent: 'center',
      borderWidth: 1,
      borderColor: WHITE,
      borderRadius: borderRadius.BORDER_RADIUS_100,
      marginLeft: spacing.SPACING_8,
      marginRight: spacing.SPACING_20
    },
    itemContainer: {
      marginVertical: spacing.SPACING_16
    },
    footerContainer: Object.assign(Object.assign({
      width: '100%',
      marginBottom: spacing.SPACING_20
    }, checkIsPlatform('web') && {
      position: 'sticky',
      bottom: 0,
      paddingBottom: spacing.SPACING_8
    }), !checkIsPlatform('web') && {
      paddingBottom: spacing.SPACING_8,
      position: 'relative'
    }),
    footerBtnContainer: {
      paddingHorizontal: isInsideModal ? spacing.SPACING_0 : spacing.SPACING_20
    },
    dividerStyle: Object.assign({
      marginBottom: spacing.SPACING_16,
      borderBottomColor: LILAC_500
    }, checkIsPlatform('web') && {
      width: "calc(100% + 40px)",
      left: '50%',
      transform: "translateX(-50%)",
      position: 'relative'
    })
  });
};